import authInstance from "config/axios.config";

export const offerServices = {
    getOffers: async ({ page, limit, status, discountType, search, sortBy,
    order}) => {
        const params = new URLSearchParams({
          page: page?.toString() || "1",
          limit: limit?.toString() || "10",
          status: status || "",
          discountType: discountType || "",
          search: search || "",
          sortBy: sortBy || "createdAt",
          order: order || "desc",            
        });

        // Remove empty params
        for (const [key, value] of [...params.entries()]) {
            if (!value) params.delete(key);
        }

        const res = await authInstance.get(`/admin/offers/list?${params}`);
        return res.data;
    },

    getOfferById: async (offerId) => {
        const res = await authInstance.get(`/admin/offers/${offerId}`);
        return res.data;
    },

    addOffer: async (offerData) => {
        const res = await authInstance.post("/admin/offers/create", offerData);
        return res.data;
    },

    updateOffer: async ({ offerId, offerData }) => {
        const res = await authInstance.put(`/admin/offers/update/${offerId}`, offerData);
        return res.data;
    },

    deleteOffer: async (offerId) => {
        const res = await authInstance.delete(`/admin/offers/${offerId}`);
        return res.data;
    },

    exportOffers: async (
  filters
) => {

  const params = new URLSearchParams({
  search: filters.search || '',
  status: filters.status || '',
  discountType: filters.discountType || '',
  sortBy: filters.sortBy || 'createdAt',
  order: filters.order || 'desc',
});

  return authInstance.get(
    `/admin/offers/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
}